import * as React from 'react';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionSummary, { AccordionSummaryProps } from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';

export const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `0px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}));

export const AccordionSummary = styled((props: AccordionSummaryProps & { bgColor: string }) => (
  <MuiAccordionSummary
    sx={{backgroundColor: props.bgColor}}
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '10px', color: '#fff' }} />}
    {...props}
  />
))(({ theme }) => ({
  minHeight: 30,
  padding: 5,
  color: '#fff',
  fontSize: 13,
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    margin: 0,
    marginLeft: 5,
    padding: 0,
  },
}));

export const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: 0,
  fontSize: 13,
  height: 150,
  overflowY: 'auto',
  borderTop: '0px solid rgba(0, 0, 0, .125)',
}));